const roundDate = (date: Date, milliseconds: number) =>
    Math.round(date.getTime() / milliseconds) * milliseconds;

export default roundDate;
